<template>
    <div>
        <NavBarAdmin></NavBarAdmin>
        <h3 class="mt-3">Nueva forma para la línea láminas metálicas</h3>
        <NewImgForm class="mb-2"></NewImgForm>
        <FooterAdmin></FooterAdmin>
    </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue"
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue"
import NewImgForm from "@/components/Admin/Sheet/NewImgSheetFormComponent.vue"
export default{
 components:{
    NavBarAdmin,
    FooterAdmin,
    NewImgForm,
 }
}
</script>
<style>
</style>